// extracted by mini-css-extract-plugin
export default {"statistics_number":"DashboardRewardRedeem_statistics_number__YoQF-"};